import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ChatService {
  private readonly _http = inject(HttpClient);

  private readonly _apiUrl = environment.apiUrl;

  getChatList(userId: number) {
    return this._http.get<any>(`${this._apiUrl}/get-usersgroup-chat/${userId}`);
  }

  // Room id is a combination of user id and chat id separated by a comma
  getIndividualChat(roomId: string) {
    return this._http.get<any>(`${this._apiUrl}/get-chat/${roomId}`);
  }

  getGroupChat(roomId: number) {
    return this._http.get<any>(`${this._apiUrl}/get-chat/${roomId}`);
  }

  readChat(userId: number, data: any) {
    return this._http.post<any>(`${this._apiUrl}/read-messages-mysql/${userId}`, data);
  }

  deleteChat(userId: number, data: any) {
    return this._http.post<any>(`${this._apiUrl}/delete-chat/${userId}`, data);
  }

  deleteMultipleChats(userId: number, data: any) {
    const body = {
      msgId: data,
    };
    return this._http.post<any>(`${this._apiUrl}/delete-multiple-chat-message/${userId}`, body);
  }

  createChatMessage(formData: FormData) {
    const headers = new HttpHeaders({ 'X-No-Dedup': 'true' });
    return this._http.post<any>(`${this._apiUrl}/store-messages-mysql`, formData, { headers });
  }

  deleteChatMessage(userId: number, data: any) {
    return this._http.post<any>(`${this._apiUrl}/delete-chat-message/${userId}`, data);
  }

  getCommonGroups(data: any) {
    return this._http.post<any>(`${this._apiUrl}/get-common-groups`, data);
  }

  markAsRead() {
    return this._http.get(`${this._apiUrl}/mark-as-read/messages`);
  }
}
